import React from "react";
import styled from "styled-components";
import Bar from "./Bar"
import Label from "./Label"

const StyledColumn = styled.div`
  background-color: white;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 11%;
`;

const Column = ({ data, column, index, handleIndexChange, selected }) => {
  const height = data.reduce((max, val) => Math.max(max, Math.abs(val.value)), 0)
  return (
    <StyledColumn onClick={() => handleIndexChange(index)} >
      <Bar height={height} value={column.value} current={index === data.length - 1} selected={selected} />
      <Label label={column.label} value={column.value} current={index === data.length - 1} selected={selected} />
    </StyledColumn>
  );
}

export default Column;


// WEBPACK FOOTER //
// ./src/artzu-ui/src/BarGraph/Column.js